import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ToastProvider } from '@shripos/ui';
import './i18n/index.js';
import { queryClient } from './lib/api.js';
import { router } from './router.jsx';
import { UpdatePrompt } from './components/UpdatePrompt.jsx';
import { OverrideHost, PrintHost } from './components/Hosts.jsx';
import './index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
        <UpdatePrompt />
        <OverrideHost />
        <PrintHost />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
